<template>
  <b-modal @hide="modalClose" ref="processKindsModal" :title="$t('工程区分選択')" size="lg" hide-footer>
    <b-container fluid>
      <div v-if="this.baseProcess.sort !== 1 || !this.arrangement" class="modal-section-type">
        <p class="modal-section-type-title">{{$t('社内工程')}}</p>
        <template v-for="(inHouseParent, index) in inHouse">
          <div
            :key="`inHouseParent-${index}`"
            class="modal-section-type-box"
          >
            <p class="modal-section-type-name">{{ $t(inHouseParent.messageKey) }}</p>
            <div
            class="d-flex flex-wrap">
              <template v-for="(inHouseChild, num) in inHouseParent.datas">
                <div v-if="inHouseChild.isInSource" :key="`inHouseChild-${index}-${num}`" class="mr-4 mb-3 form-check">
                  <input @click="changeProcessKind(inHouseChild,false)" class="form-check-input" type="radio" name="processKindsRadio" :id="`inHouseChild-${inHouseChild.id}`" :value="inHouseChild.id" :checked="inHouseChild.id === baseProcess.processKindId && !baseProcess.isOutSource">
                  <label class="form-check-label ml-2" :for="`inHouseChild-${inHouseChild.id}`">
                    {{ $t(inHouseChild.messageKey) }}
                  </label>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="processKind">
        <p>{{$t('外注工程')}}</p>
        <template v-for="(outSourcingParent, index) in outSource">
          <div
          :id="`outSourcingParent-${index}`"
          :key="`outSourcingParent-${index}`" class="modal-section-type-box">
            <p class="modal-section-type-name">{{ $t(outSourcingParent.messageKey) }}</p>
            <div
            class="d-flex flex-wrap">
              <template v-for="(outSourcingChild, num) in outSourcingParent.datas">
                <div v-if="outSourcingChild.isOutSource && !outSourcingChild.isMaterialPrepare" :key="`outSourcingChild-${index}-${num}`" class="mr-4 mb-3 form-check">
                  <input @click="changeProcessKind(outSourcingChild,true)" class="form-check-input" type="radio" name="processKindsRadio" :id="`outSourcingChild-${outSourcingChild.id}`" :value="outSourcingChild.id" :checked="outSourcingChild.id === baseProcess.processKindId && baseProcess.isOutSource">
                  <label class="form-check-label ml-2" :for="`outSourcingChild-${outSourcingChild.id}`">
                    {{ $t(outSourcingChild.messageKey) }}
                  </label>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </b-container>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    processes: {
      type: Array,
      default: () => [],
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    arrangement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      error: '',
      registering: false,
      baseProcess: {},
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(item) {
      this.$refs.processKindsModal.show()
      this.baseProcess = item
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.baseProcess = {}
      for (const element of document.getElementsByName('processKindsRadio')) {
        element.checked = false
      }
      this.$refs.processKindsModal.hide()
    },
    changeProcessKind(processKindData, boolean) {
      this.$emit(
        'changeProcessKind',
        {
          sort: this.baseProcess.sort,
          processKindId: Number(processKindData.id),
          isOutSource: boolean,
          messageKey: processKindData.messageKey,
        }
      )
      this.modalClose()
    },
  },
  computed: {
    inHouse() {
      if (this.processKinds.length === 0) return []
      return this.processKinds.filter(data => {
        if (data.datas.length === 0) return false
        const tmpDatas = data.datas.filter(item => item.isInSource)
        if (tmpDatas.length === 0) return false
        return true
      })
    },
    outSource() {
      if (this.processKinds.length === 0) return []
      return this.processKinds.filter(data => {
        if (data.datas.length === 0) return false
        const tmpDatas = data.datas.filter(item => item.isOutSource)
        if (tmpDatas.length === 0) return false
        return true
      })
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
.processKind {
  border: solid 2px #ddd;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
.modal-section-type {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 10px;
  border: solid 2px #ddd;
  text-align: left;

  &-title {
    margin: 0 0 1rem 0;
    font-size: 1.6rem;
    font-weight: bold;
  }

  &-name {
    font-size: 1.6rem;
    font-weight: bold;
  }

  &-box {
    margin-bottom: 1.5rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
